import React from 'react';
import { classIf } from '../../data/utils';
import { useUISettings } from '../../UISettingsProvider';
import LandingCarousel from '../../landing/LandingCarousel';
import { systemCode } from '../..';

const HBG_SKINS = [
    'YOUBET',
    'TREBET',
    'QUIGIOCO',
    'MILLIONAIREBET',
    'GSBET365',
    'BET2020'
];

export default function PrematchHomeContentWrapper(props) {
    const uiSettings = useUISettings();

    return (
        <div className={"competizione-interna dueColonne dueColonne_Template_1" + classIf(uiSettings.fullScreen, 'unaColonna')}>
            <div id="primo-blocco-sport" className={"sport-blocco primo-blocco-sport go-up-arrow-on-overflow" + classIf(uiSettings.fullScreen, 'no-margin')}>
                {HBG_SKINS.includes(systemCode) &&
                    <div className="margine-giu">
                        <LandingCarousel />
                    </div>
                }
                {props.children[0]}
            </div>
            {props.children[1]}
        </div>
    );
}
